import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import React, { useMemo, useRef, useState } from 'react'
import { CommentReplyAcceptProps, CommentReplyProps } from './interface'

const withCommentReply = (Component: React.FC<CommentReplyProps>) => {
  function WithCommentReply({
    comment,
    user,
    visibleSubComment = false,
    ...props
  }: CommentReplyAcceptProps) {
    const { isNightOrDarkTheme, isLightOrSepiaTheme } = useTheme()
    const [isReadmore, setIsReadmore] = useState<boolean>(visibleSubComment)
    const replyCommentBoxRef = useRef<any>(null)

    function handleClickReadmore() {
      setIsReadmore(true)
      setTimeout(() => {
        replyCommentBoxRef?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }, 100)
    }

    const lastIndex = useMemo(() => {
      let index = 0
      comment.childrenComment.forEach((child, i) => {
        if (!child.replied) {
          index = i
        }
      })
      return index
    }, [comment])

    const newProps = {
      handleClickReadmore,
      isReadmore,
      lastIndex,
      comment,
      replyCommentBoxRef,
      user,
      isNightOrDarkTheme,
      isLightOrSepiaTheme,
      ...props,
    }
    return <Component {...newProps} />
  }

  return WithCommentReply
}

export default withCommentReply
